<template>
  <div class="page-content">
    <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="taskName"
          label="任务名称">
        </el-table-column>
        <el-table-column
          prop="startTime"
          label="数据开始时间">
        </el-table-column>
        <el-table-column
          prop="endTime"
          label="数据结束时间">
        </el-table-column>
        <el-table-column
          prop="taskTimerStatus"
          label="该次任务执行状态">
          <template slot-scope="scope">
            <div>
              {{scope.row.taskTimerStatus? '成功': '失败'}}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <Paging
          :total="total"
          pagingStatus=""
          @changePage="currentChange"/>
  </div>
</template>
<script>
import { timeLogList } from '@/api/dataAnalyst'
import Paging from '@/components/paging'
export default {
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  data () {
    return {
      pageParams: {
        pageSize: 10,
        pageNumber: 1
      },
      total: 0,
      tableData: []
    }
  },
  components: {
    Paging
  },
  methods: {
    getTaskLogList (searchParams) {
      const params = {
        params: {
          pageSize: this.pageParams.pageSize,
          pageNumber: this.pageParams.pageNumber
        }
      }
      timeLogList(params).then(res => {
        const resData = res.data.data
        this.total = resData.recordCount
        this.tableData = resData.list
      })
    },
    currentChange (val) {
      Object.assign(this.pageParams, {
        pageSize: val.limit,
        pageNumber: val.page
      })
      this.getTaskLogList()
    }
  },
  created () {
    this.getTaskLogList()
  }
}
</script>
<style lang="less" scope>
.page-content{
  .footer{
      padding: 20px 10px ;
    }
  .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
}
</style>
